import { render } from "./answerDel.vue?vue&type=template&id=5ab9dfbc"
import script from "./answerDel.vue?vue&type=script&lang=js"
export * from "./answerDel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__